<template>
    <div>
        <page-header :header-title="` `" :header_logo="true" :header_side="true">
            <button slot="headerBtns" class="h_search_btn" @click="$router.push('/search')"></button>
        </page-header>
        <page-header class="sub_header"></page-header>
        <item-detail-component :item-type="'entryDetail'" :item-key="entryKey"></item-detail-component>
        <popup-modal></popup-modal>
    </div>
</template>

<script>
import ItemDetailComponent from "@/components/item/ItemDetailComponent";
import PopupModal from "@/components/modal/PopupModal";

export default {
    name: "EntryDetail",
    mixins: [],
    components: {
        PopupModal,
        ItemDetailComponent,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            entryKey: this.$route.params.idx
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
